import React from "react";
import { Routes, Route, Outlet } from "react-router-dom"; 
import Home from "../pages/home/Home";
import Babaji from "../pages/home/Babaji";
import Header from "components/common/Header/Header2/Header";
import Footer from "components/common/Header/Footer/Footer";
import PranPratishtaPage from "pages/Pranpratisthapana";
import DonationPage from "pages/Donation";
import ContactUs from "pages/ContactUs/ContactUs";
import ContactPage from "pages/ContactPage";
import TermsandCondition from "pages/Terms";
import TermsCondition from "pages/Terms";
import PrivacyPolicy from "pages/PrivacyPolicy";
import RefundPage from "pages/Refund";
import DharmikSankapana from "pages/DharmikSankalpana";
import BhaktaParivar from "pages/BhaktaParivar/BhaktaParivar";

const HeaderOutlet = () => {
    return (
        <div>
            <Header />
            <div className="main-container">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
};

const OnlyHeaderandFooter = () => {
    return (
        <div>
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
};

const Routing = () => {
    return (
        <section className="routing">
            <Routes>
                {/* Main route with Header */}
                <Route element={<OnlyHeaderandFooter />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/babaji" element={<Babaji />} />
                    <Route path="/pranpratisthapana" element={<PranPratishtaPage />} />
                    <Route path="/contact-us" element={<ContactPage />} />
                    <Route path="/donation" element={<DonationPage />} />
                    <Route path="/bhakta-parivar" element={<BhaktaParivar />} />
                    <Route path="/dharmik-sankalpana" element={<DharmikSankapana />} />
                    <Route path="/terms-conditions" element={<TermsCondition />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/refund-policy" element={<RefundPage />} />
                </Route>
            </Routes>
        </section>
    );
};

export default Routing;
